import React, { useEffect, useState } from "react";
import HomeHeader from "./HomeHeader";
import HomeGuideBanner from "./HomeGuideBanner";
import HomeMonthlyTrend from "./HomeMonthlyTrend";
import HomeRecommendMerchant from "./HomeRecommendMerchant";
import HomeTodayCommunity from "./HomeTodayCommunity";
import HomeFooter from "./HomeFooter";
import { HomeSection, HomeWrapper } from "./HomeStyle";
// import { socket } from "services/socket";
// import io from "socket.io-client";
import { useSelector, useDispatch } from "react-redux";

import { useNavigate, useLocation, Link } from "react-router-dom";

import authCheck from "components/common/useAuthCheck";
import { UserCreators } from "redux/modules/user";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const [auth, setAuth] = useState(false);

  const status = useSelector((state) => state.user.userInfo.success);
  const userId = useSelector((state) => state.user.userInfo.userId);
  const level = useSelector((state) => state.user.userInfo.level);

  useEffect(() => {
    dispatch(UserCreators.getUserInfos());

    if (status === true) {
      localStorage.setItem("userId", userId);
    }

    if (state === "fromLogin") {
      setAuth(true);
    } else {
      const enter = authCheck("NORMAL");
      if (enter === true) {
        setAuth(true);
      } else {
        navigate("/login");
      }
    }

    // socket testing
    // socket.on("connect", () => {
    //   console.log("socketId : ", socket.id);
    // });

    // return () => {
    //   console.log("disconnect");
    //   socket.disconnect();
    // };
  }, [userId, status, auth]);

  if (auth === true) {
    return (
      <HomeWrapper>
        <HomeSection>
          <HomeHeader />
          <HomeGuideBanner />
          <HomeMonthlyTrend />
          <HomeRecommendMerchant />
          <HomeTodayCommunity />
          <HomeFooter />
        </HomeSection>
      </HomeWrapper>
    );
  } else {
    return <Link to="/login" />;
  }
};

export default Home;
